module.exports = __webpack_public_path__ + "img/Rectangle 252@2x.6343160f.png";